// MultipleFiles/LandingPage.jsx (Modified sections)
import React, { useState, useEffect } from 'react';

// ... existing translations and locationData ...
const translations = {
    en: {
        headline: 'Print online, Free Delivery.',
        subtitle: 'Fast, local, no delivery fees',
        cta: 'Start Printing',
        selectCountry: 'Select Country',
        selectRegion: 'Select Region',
        selectCity: 'Select City',
        partnerSignIn: 'Printing partner sign in'
    },
    fr: {
      headline: 'Imprimez en ligne,  Livraison gratuite.',
      subtitle: 'Rapide, local, sans frais de livraison',
      cta: 'Commencer à imprimer',
      selectCountry: 'Sélectionner le pays',
      selectRegion: 'Sélectionner la région',
      selectCity: 'Sélectionner la ville',
      partnerSignIn: 'Connexion partenaire d\'impression'
   },
   ar: {
    headline: 'اطبع اونلاين و توصيل بلاش',
    subtitle: 'سريع، محلي، بلا مصاريف توصيل',
    cta: 'ابدأ الطباعة',
    selectCountry: 'اختار البلد',
    selectRegion: 'اختار المنطقة',
    selectCity: 'اختار المدينة',
    partnerSignIn: 'دخول شريك الطباعة'
}
};

const locationData = {
    canada: {
        'Toronto': [], // User sees "Toronto" but backend gets Ontario/Toronto
        'Montreal': [] // Add Montreal here
    },
  tunisia: {
    'Sousse': [] // User sees "Sousse" as region
  },
  'united states': {
    'Alabama': ['Birmingham', 'Montgomery', 'Mobile'],
    'Alaska': ['Anchorage', 'Fairbanks', 'Juneau'],
    'Arizona': ['Phoenix', 'Tucson', 'Mesa'],
    'Arkansas': ['Little Rock', 'Fort Smith', 'Fayetteville'],
    'California': ['Los Angeles', 'San Francisco', 'San Diego'],
    'Colorado': ['Denver', 'Colorado Springs', 'Aurora'],
    'Connecticut': ['Bridgeport', 'New Haven', 'Stamford'],
    'Delaware': ['Wilmington', 'Dover', 'Newark'],
    'Florida': ['Miami', 'Orlando', 'Tampa'],
    'Georgia': ['Atlanta', 'Augusta', 'Columbus'],
    'Hawaii': ['Honolulu', 'East Honolulu', 'Pearl City'],
    'Idaho': ['Boise', 'Nampa', 'Meridian'],
    'Illinois': ['Chicago', 'Aurora', 'Rockford'],
    'Indiana': ['Indianapolis', 'Fort Wayne', 'Evansville'],
    'Iowa': ['Des Moines', 'Cedar Rapids', 'Davenport'],
    'Kansas': ['Wichita', 'Overland Park', 'Kansas City'],
    'Kentucky': ['Louisville', 'Lexington', 'Bowling Green'],
    'Louisiana': ['New Orleans', 'Baton Rouge', 'Shreveport'],
    'Maine': ['Portland', 'Lewiston', 'Bangor'],
    'Maryland': ['Baltimore', 'Frederick', 'Rockville'],
    'Massachusetts': ['Boston', 'Worcester', 'Springfield'],
    'Michigan': ['Detroit', 'Grand Rapids', 'Warren'],
    'Minnesota': ['Minneapolis', 'Saint Paul', 'Rochester'],
    'Mississippi': ['Jackson', 'Gulfport', 'Southaven'],
    'Missouri': ['Kansas City', 'St. Louis', 'Springfield'],
    'Montana': ['Billings', 'Missoula', 'Great Falls'],
    'Nebraska': ['Omaha', 'Lincoln', 'Bellevue'],
    'Nevada': ['Las Vegas', 'Henderson', 'Reno'],
    'New Hampshire': ['Manchester', 'Nashua', 'Concord'],
    'New Jersey': ['Newark', 'Jersey City', 'Paterson'],
    'New Mexico': ['Albuquerque', 'Las Cruces', 'Rio Rancho'],
    'New York': ['New York City', 'Buffalo', 'Rochester'],
    'North Carolina': ['Charlotte', 'Raleigh', 'Greensboro'],
    'North Dakota': ['Fargo', 'Bismarck', 'Grand Forks'],
    'Ohio': ['Columbus', 'Cleveland', 'Cincinnati'],
    'Oklahoma': ['Oklahoma City', 'Tulsa', 'Norman'],
    'Oregon': ['Portland', 'Salem', 'Eugene'],
    'Pennsylvania': ['Philadelphia', 'Pittsburgh', 'Allentown'],
    'Rhode Island': ['Providence', 'Warwick', 'Cranston'],
    'South Carolina': ['Charleston', 'Columbia', 'North Charleston'],
    'South Dakota': ['Sioux Falls', 'Rapid City', 'Aberdeen'],
    'Tennessee': ['Nashville', 'Memphis', 'Knoxville'],
    'Texas': ['Houston', 'Dallas', 'Austin'],
    'Utah': ['Salt Lake City', 'West Valley City', 'Provo'],
    'Vermont': ['Burlington', 'South Burlington', 'Rutland'],
    'Virginia': ['Virginia Beach', 'Norfolk', 'Chesapeake'],
    'Washington': ['Seattle', 'Spokane', 'Tacoma'],
    'West Virginia': ['Charleston', 'Huntington', 'Morgantown'],
    'Wisconsin': ['Milwaukee', 'Madison', 'Green Bay'],
    'Wyoming': ['Cheyenne', 'Casper', 'Laramie'],
    'District of Columbia': ['Washington']
  },
  'united kingdom': {},
  germany: {},
  france: {},
  spain: {},
  italy: {},
  australia: {},
  india: {},
  brazil: {},
  mexico: {},
  japan: {},
  china: {},
  argentina: {},
  'south africa': {},
  egypt: {},
  nigeria: {},
  indonesia: {},
  pakistan: {},
  bangladesh: {},
  philippines: {},
  vietnam: {},
  thailand: {},
  turkey: {},
  'saudi arabia': {},
  'united arab emirates': {},
  malaysia: {},
  singapore: {},
  'new zealand': {},
  ireland: {},
  sweden: {},
  norway: {},
  denmark: {},
  finland: {},
  netherlands: {},
  belgium: {},
  switzerland: {},
  austria: {},
  greece: {},
  portugal: {},
  poland: {},
  'czech republic': {},
  hungary: {},
  romania: {},
  'south korea': {}
};
const LandingPage = ({ onStartPrinting, onCountryChange, onRegionChange, isLoggedIn, setShowAuthModal, setAuthMode }) => {
    const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem('selectedLanguage') || 'en');
    const [selectedCountry, setSelectedCountry] = useState(localStorage.getItem('selectedCountry') || '');
    const [selectedRegion, setSelectedRegion] = useState(localStorage.getItem('selectedRegion') || '');
    const [selectedCity, setSelectedCity] = useState('');
    const [isCtaEnabled, setIsCtaEnabled] = useState(false);
    const [ipDetectionCompleted, setIpDetectionCompleted] = useState(false);

    const currentTranslations = translations[selectedLanguage];

    useEffect(() => {
        // If user is logged in, bypass landing page logic and enable CTA
        if (isLoggedIn) {
            setIsCtaEnabled(true);
            setIpDetectionCompleted(true); // Mark detection as complete to avoid running it
            // Optionally, you might want to directly call onStartPrinting here
            // if the intention is to always skip the landing page for logged-in users.
            // For now, we'll let the user click "Start Printing".
            return;
        }

        const detectCountryAndSetLanguage = async () => {
            if (!localStorage.getItem('selectedLanguage') && !localStorage.getItem('selectedCountry')) {
                try {
                    const response = await fetch('https://freezepix-database-server-c95d4dd2046d.herokuapp.com/api/detect-location', {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    const data = await response.json();
                    const countryCode = data.countryCode || data.country_code || data.country;
                    const countryName = data.country || data.country_name;

                    if (countryCode === 'TN' || countryName === 'Tunisia') {
                        setSelectedLanguage('ar'); // Default language for Tunisia
                        setSelectedCountry('tunisia');
                        setSelectedRegion('Sousse');
                        localStorage.setItem('selectedLanguage', 'ar');
                        localStorage.setItem('selectedCountry', 'tunisia');
                        localStorage.setItem('selectedRegion', 'Sousse');
                    } else if (countryCode === 'CA' || countryName === 'Canada') {
                        setSelectedLanguage('en');
                        setSelectedCountry('canada');
                        setSelectedRegion('Toronto');
                        localStorage.setItem('selectedLanguage', 'en');
                        localStorage.setItem('selectedCountry', 'canada');
                        localStorage.setItem('selectedRegion', 'Toronto');
                    } else {
                        setSelectedLanguage('en');
                        localStorage.setItem('selectedLanguage', 'en');
                    }
                } catch (error) {
                    console.error("Error detecting IP location:", error);
                    setSelectedLanguage('en');
                    localStorage.setItem('selectedLanguage', 'en');
                }
            }
            setIpDetectionCompleted(true);
        };

        detectCountryAndSetLanguage();
    }, [isLoggedIn]); // Add isLoggedIn to dependencies

    useEffect(() => {
        // CTA is enabled if logged in, or if country and region are selected and IP detection is complete
        setIsCtaEnabled(isLoggedIn || (selectedCountry !== '' && selectedRegion !== '' && ipDetectionCompleted));
    }, [selectedCountry, selectedRegion, isLoggedIn, ipDetectionCompleted]);

    const handleCountryChange = (e) => {
        const country = e.target.value;
        setSelectedCountry(country);
        localStorage.setItem('selectedCountry', country);
        if (onCountryChange) {
            onCountryChange(country);
        }
        setSelectedRegion('');
        localStorage.removeItem('selectedRegion');
        setSelectedCity('');
        localStorage.removeItem('selectedCity');
    };

    const handleRegionChange = (e) => {
        const region = e.target.value;
        setSelectedRegion(region);
        localStorage.setItem('selectedRegion', region);
        if (onRegionChange) {
            onRegionChange(region);
        }
        setSelectedCity('');
        localStorage.removeItem('selectedCity');
    };

    const handleStartPrinting = () => {
        if (isCtaEnabled) {
            if (!isLoggedIn) { // Only save to sessionStorage if not logged in
                sessionStorage.setItem('selectedCountry', selectedCountry.toLowerCase());
                if (selectedRegion === 'Toronto') {
                    sessionStorage.setItem('selectedRegion', 'Ontario');
                    sessionStorage.setItem('selectedCity', 'Toronto');
                } else {
                    sessionStorage.setItem('selectedRegion', selectedRegion);
                    sessionStorage.setItem('selectedCity', '');
                }
                sessionStorage.setItem('selectedLanguage', selectedLanguage);
            }
            onStartPrinting();
        }
    };

    return (
        <section className="hero">
      <style>{`
                * {
                    margin: 0;
                    padding: 0;
                    box-sizing: border-box;
                }

                body {
                    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #2196F3 100%);
                    min-height: 100vh;
                    overflow: hidden;
                }

                .hero {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    min-height: 100vh;
                    text-align: center;
                    padding: 40px 20px 20px;
                    position: relative;
                }

                .hero-content {
                    max-width: 900px;
                    z-index: 10;
                }

                .logo-container {
                    display: flex;
                    justify-content: center;
                    margin-bottom: 40px;
                }

                .logo-placeholder {
                    width: 280px;
                    height: 90px;
                    background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 248, 248, 0.96) 100%);
                    border-radius: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 
                        0 15px 50px rgba(255, 255, 255, 0.25),
                        0 5px 20px rgba(33, 150, 243, 0.1);
                    backdrop-filter: blur(20px);
                    padding: 15px;
                    border: 1px solid rgba(255, 255, 255, 0.3);
                }

             .logo-placeholder img {
                    width: 100%;
                    height: 100%;
                    max-width: 280px;
                    max-height: 80px;
                    object-fit: contain;
                    filter: brightness(1.1) contrast(1.05);
                    transform: scale(2.3);
                }
                .main-headline {
                    font-size: clamp(2.5rem, 8vw, 4.5rem);
                    font-weight: 800;
                    color: white;
                    margin-bottom: 30px;
                    line-height: 1.1;
                    text-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
                }

                .highlight {
                    background: linear-gradient(135deg, #FFD700, #FFA500);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                }

                .subtitle {
                    font-size: clamp(1.1rem, 3vw, 1.4rem);
                    color: rgba(255, 255, 255, 0.8);
                    margin-bottom: 50px;
                    font-weight: 400;
                    line-height: 1.4;
                }

                .selection-controls {
                    display: flex;
                    justify-content: center;
                    gap: 20px;
                    margin-bottom: 40px;
                    flex-wrap: wrap;
                }

                .control-group {
                    display: flex;
                    flex-direction: column;
                }

                .select-box.highlighted {
                    border-color: #2196F3;
                    background: rgba(33, 150, 243, 0.2);
                    box-shadow: 0 0 20px rgba(33, 150, 243, 0.3);
                }

                .select-box {
                    padding: 15px 25px;
                    border: 2px solid rgba(255, 255, 255, 0.2);
                    border-radius: 12px;
                    background: rgba(255, 255, 255, 0.1);
                    backdrop-filter: blur(10px);
                    color: white;
                    font-size: 16px;
                    font-weight: 500;
                    min-width: 200px;
                    transition: all 0.3s ease;
                    cursor: pointer;
                }

                .select-box:focus {
                    outline: none;
                    border-color: #2196F3;
                    background: rgba(255, 255, 255, 0.15);
                    transform: translateY(-2px);
                }

                .select-box option {
                    background: #1a1a2e;
                    color: white;
                    padding: 10px;
                }

                .cta-button {
                    display: inline-block;
                    padding: 20px 50px;
                    background: linear-gradient(135deg, #2196F3, #1976D2);
                    color: white;
                    text-decoration: none;
                    border-radius: 50px;
                    font-size: 18px;
                    font-weight: 600;
                    transition: all 0.3s ease;
                    box-shadow: 0 10px 40px rgba(33, 150, 243, 0.4);
                    position: relative;
                    overflow: hidden;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                    opacity: 0.5;
                    pointer-events: none;
                    border: none;
                    cursor: pointer;
                }

                .cta-button.enabled {
                    opacity: 1;
                    pointer-events: auto;
                }

                .cta-button::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: -100%;
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
                    transition: left 0.6s ease;
                }

                .cta-button.enabled:hover::before {
                    left: 100%;
                }

                .cta-button.enabled:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 15px 50px rgba(33, 150, 243, 0.6);
                }

                /* New style for the partner sign-in link */
                .partner-signin-link {
                    display: block; /* Make it a block element to take its own line */
                    margin-top: 20px; /* Space above the link */
                    font-size: 0.9rem; /* Smaller font size */
                    color: rgba(255, 255, 255, 0.7); /* Subtle white color */
                    text-decoration: underline; /* Underline the text */
                    transition: color 0.3s ease;
                }

                .partner-signin-link:hover {
                    color: #2196F3; /* Highlight on hover */
                }

                .background-shapes {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    pointer-events: none;
                    z-index: 1;
                }

                .shape {
                    position: absolute;
                    border-radius: 50%;
                    background: rgba(255, 255, 255, 0.05);
                    animation: float 8s ease-in-out infinite;
                }

                .shape:nth-child(1) {
                    width: 300px;
                    height: 300px;
                    top: 10%;
                    left: -10%;
                    animation-delay: 0s;
                }

                .shape:nth-child(2) {
                    width: 200px;
                    height: 200px;
                    top: 60%;
                    right: -5%;
                    animation-delay: 2s;
                }

                .shape:nth-child(3) {
                    width: 150px;
                    height: 150px;
                    bottom: 20%;
                    left: 20%;
                    animation-delay: 4s;
                }

                .shape:nth-child(4) {
                    width: 100px;
                    height: 100px;
                    top: 30%;
                    right: 25%;
                    animation-delay: 1s;
                }

                @keyframes float {
                    0%, 100% { transform: translateY(0px) rotate(0deg); }
                    50% { transform: translateY(-30px) rotate(180deg); }
                }

                .grid-pattern {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-image: 
                        linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
                        linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
                    background-size: 50px 50px;
                    z-index: 0;
                }

                @media (max-width: 768px) {
                    .logo-placeholder {
                        width: 230px;
                        height: 70px;
                        padding: 12px;
                    }
                    
                    .hero {
                        padding: 30px 15px 20px;
                    }
                    
                    .selection-controls {
                        flex-direction: column;
                        align-items: center;
                        gap: 15px;
                    }
                    
                    .select-box {
                        min-width: 280px;
                    }
                    
                    .cta-button {
                        padding: 18px 40px;
                        font-size: 16px;
                    }
                }

                @media (max-width: 480px) {
                    .logo-placeholder {
                        width: 200px;
                        height: 60px;
                        padding: 10px;
                    }
                }
            `}</style>
            <div className="grid-pattern"></div>
            <div className="background-shapes">
                <div className="shape"></div>
                <div className="shape"></div>
                <div className="shape"></div>
                <div className="shape"></div>
            </div>

            <div className="hero-content">
                <div className="logo-container">
                    <div className="logo-placeholder">
                        <img src="https://cdn.shopify.com/s/files/1/0671/1387/7804/files/quickprinthub-removebg-preview.png?v=1752340233" alt="QuickPrintHub Logo" onError={(e) => { e.target.style.display = 'none'; e.target.parentElement.innerHTML = 'QuickPrintHub'; }} />
                    </div>
                </div>

                <h1 className="main-headline" dangerouslySetInnerHTML={{ __html: currentTranslations.headline }}></h1>

                <p className="subtitle">{currentTranslations.subtitle}</p>

                {!isLoggedIn && ( // Only show selection controls if not logged in
                    <div className="selection-controls">
                        <div className="control-group">
                            <select className="select-box" id="language" value={selectedLanguage} onChange={(e) => {
                                setSelectedLanguage(e.target.value);
                                localStorage.setItem('selectedLanguage', e.target.value);
                            }}>
                                <option value="en">English</option>
                                <option value="fr">Français</option>
                                <option value="ar">العربية (تونس)</option>
                            </select>
                        </div>

                        <div className="control-group">
                            <select className="select-box highlighted" id="country" value={selectedCountry} onChange={handleCountryChange}>
                                <option value="">{currentTranslations.selectCountry}</option>
                                {Object.keys(locationData).sort((a, b) => {
                                    if (a === 'tunisia') return -1;
                                    if (b === 'tunisia') return 1;
                                    if (a === 'canada') return -1;
                                    if (b === 'canada') return 1;
                                    return a.localeCompare(b);
                                }).map(countryKey => (
                                    <option key={countryKey} value={countryKey}>
                                        {countryKey.charAt(0).toUpperCase() + countryKey.slice(1)}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="control-group">
                            <select className="select-box" id="region" style={{ display: selectedCountry && Object.keys(locationData[selectedCountry]).length > 0 ? 'block' : 'none' }} value={selectedRegion} onChange={handleRegionChange}>
                                <option value="">{currentTranslations.selectRegion}</option>
                                {selectedCountry && locationData[selectedCountry] && Object.keys(locationData[selectedCountry]).length > 0 ? (
                                    Object.keys(locationData[selectedCountry]).map(region => (
                                        <option key={region} value={region}>{region}</option>
                                    ))
                                ) : (
                                    <option value="" disabled>{currentTranslations.selectRegion} (No available)</option>
                                )}
                            </select>
                        </div>
                    </div>
                )}

                <button
                    onClick={handleStartPrinting}
                    className={`cta-button ${isCtaEnabled ? 'enabled' : ''}`}
                >
                    {currentTranslations.cta}
                </button>

                {!isLoggedIn && ( // Show login/register links only if not logged in
        <div className="mt-6">
            <button
                onClick={() => { setShowAuthModal(true); setAuthMode('login'); }}
                className="partner-signin-link mr-4"
            >
                {currentTranslations.login}
            </button>
            <button
                onClick={() => { setShowAuthModal(true); setAuthMode('register'); }}
                className="partner-signin-link"
            >
                {currentTranslations.register}
            </button>
        </div>
    )}

                {isLoggedIn && ( // Show partner sign-in only if logged in (or if it's a separate portal)
                    <a
                        href="https://admin.quickprinthub.com/hub-login"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="partner-signin-link"
                    >
                        {currentTranslations.partnerSignIn}
                    </a>
                )}
            </div>
        </section>
    );
};

export default LandingPage;
